import VASTClient from '../../../formats/video-sdk3/lib/vast/vast-client';
import {
  VPAIDAdUnitV2,
  getDispatchedEvents,
  AdUnitVersion,
  AdUnitEventName
} from '../../../@types/vpaid.type';

interface EventListener {
  func: (...args: any[]) => void;
  priority?: number;
}

export class AdUnitEventListener {
  _eventListeners: {
    [eventName: string]: EventListener[];
  } = {};

  _adUnit!: VPAIDAdUnitV2;
  _vast!: VASTClient;

  _eventsPreProcessors: {
    [eventName: string]: (...args: any[]) => any[];
  } = {
    AdClickThru: (vpaidUrl: string, _id: any, playerHandles: boolean) => {
      return [vpaidUrl, playerHandles];
    },
    AdError: (error: any) => {
      return [this._vast, error];
    },
    AdVolumeChange: () => {
      try {
        if (typeof this._adUnit.getAdVolume === 'function') {
          return [this._adUnit.getAdVolume()];
        }

        return [this._adUnit.adVolume];
      } catch {
        return [-1];
      }
    }
  };

  addEventListener(
    eventName: AdUnitEventName,
    callback: (...args: any[]) => void,
    priority?: number
  ): void {
    if (!this._eventListeners[eventName]) {
      this._eventListeners[eventName] = [];
    }
    this._eventListeners[eventName].push({
      func: callback,
      priority: priority === undefined ? 1 : priority
    });

    this._eventListeners[eventName].sort((a, b) => {
      return (a.priority || 1) - (b.priority || 1);
    });
  }

  dispatchEvent(eventName: AdUnitEventName, args: any[]): void {
    const self = this;

    args = this._preProcessArgs(eventName, args);

    if (this._eventListeners[eventName]) {
      this._eventListeners[eventName].forEach(cb => {
        cb.func.apply(self, args);
      });
    }
  }

  initEventListener(
    adUnitVersion: AdUnitVersion,
    adUnit: VPAIDAdUnitV2,
    vast: VASTClient
  ): void {
    this._adUnit = adUnit;
    this._vast = vast;
    this._subscribeEvents(adUnitVersion);
  }

  _subscribeEvents(adUnitVersion: AdUnitVersion): void {
    const supportedEvents = getDispatchedEvents(adUnitVersion);
    for (let i = 0; i < supportedEvents.length; i++) {
      const eventName: AdUnitEventName = supportedEvents[i];
      if (this._adUnit) {
        this._adUnit.subscribe((...args: any[]) => {
          this.dispatchEvent(eventName, args);
        }, eventName);
      }
    }
  }

  _preProcessArgs(eventName: AdUnitEventName, args: any[]): any[] {
    const argsPreprocessor = this._eventsPreProcessors[eventName];
    if (argsPreprocessor) {
      args = argsPreprocessor.apply(this, args);
    }
    return args;
  }
}
